(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pro-claim-conf', {
            parent: 'entity',
            url: '/pro-claim-conf',
            data: {
                authorities: [],
                pageTitle: 'ProClaimConfs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pro-claim-conf/pro-claim-confs.html',
                    controller: 'ProClaimConfController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access);
            }]
        })
        .state('pro-claim-conf.new', {
            parent: 'pro-claim-conf',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                        controller: 'ProClaimConfDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    minTime: null,
                                    maxTime: null,
                                    isDefault: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('pro-claim-conf');
                    });
                }
            }]
        })
        .state('pro-claim-conf.edit', {
            parent: 'pro-claim-conf',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                        controller: 'ProClaimConfDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProClaimConf', function (ProClaimConf) {
                                return ProClaimConf.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('pro-claim-conf.delete', {
            parent: 'pro-claim-conf',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-delete-dialog.html',
                        controller: 'ProClaimConfDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ProClaimConf', function (ProClaimConf) {
                                return ProClaimConf.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();
